import React from 'react';
import './ListBody.css';

const ListBody = ({
  headers,
  items,
  selectedItems,
  handleSelectAll,
  handleItemSelect,
  sort,
  desc,
  handleSortChange,
  setSort,
  setDesc,
  renderActions,
  onRowClick,
  className = "",
  showFooter,
}) => {
  return (
    <div className={`table ${className}`}>
      <div className="thead">
        <div className="tr">
          {headers.map((header, index) => {
            return (
              <div 
                key={index} 
                className="th" 
                onClick={() => header.value && handleSortChange(header.value, sort, setSort, setDesc)}
                style={{ cursor: header.value ? 'pointer' : 'default' }}
              >
                {header.name} {header.value !== "" && sort === header.value ? (desc === 'desc' ? '▼' : '▲') : ''}
              </div>
            );
          })}
          {renderActions && <div className="th">액션</div>}
        </div>
      </div>
      <div className="tbody">
        {items && items.length > 0 ? (
          items.map((item, index) => {
            return (
              <div 
                key={index} 
                className="tr"
                onClick={() => onRowClick && onRowClick(item)}
                style={{ cursor: onRowClick ? 'pointer' : 'default' }}
              >
                {headers.map((header, headerIndex) => (
                  <div key={headerIndex} className="td">
                    <label>{header.name}</label>
                    <span>
                      {header.renderCell ? header.renderCell(item, index) : item[header.value]}
                    </span>
                  </div>
                ))}
                {renderActions && (
                  <div className="td">
                    {renderActions(item, index)}
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <div className="tr">
            <div className="td" colSpan={headers.length + (renderActions ? 2 : 1)} style={{ textAlign: 'center' }}>
              데이터가 없습니다.
            </div>
          </div>
        )}
      </div>
      {showFooter && (
        <div className="tfoot">
          <div className="tr">
            {headers.map((header, index) => (
              <div key={index} className="td">
                {header.renderFooterCell ? header.renderFooterCell(items) : null}
              </div>
            ))}
            {renderActions && <div className="td" />}
          </div>
        </div>
      )}
    </div>
  );
};

export default ListBody;